























import Badge from '../badge.component.vue';
import { UiSwitch } from '../keen-ui';

export default {
  name: 'enabled-field',
  props: {
    value: {
      type: Boolean,
      required: true
    },
    info: String,
    disabled: Boolean,
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    UiSwitch,
    Badge
  },
  computed: {
    label: function (): string {
      return this.value ? this.messages.states.enabled : this.messages.states.disabled;
    }
  }
};
